export type SortDirection = 'asc' | 'desc';

export type SortConfig = {
    field: string;
    direction: SortDirection;
};

export const sortConfigToQueryParam = (sort: SortConfig | null): string | null => {
    if (!sort) return null;

    const snakeCaseField = sort.field.replace(/([A-Z])/g, '_$1').toLowerCase();

    return sort.direction === 'desc'
        ? `-${snakeCaseField}`
        : snakeCaseField;
};


export const DEFAULT_SORT: SortConfig = {
    field: 'createdDate',
    direction: 'desc'
};
